import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { InfoboxModule } from '@recruitee/components/infobox';
import { I18nModule } from '@recruitee/i18n';

import { CompanyDeletionComponent } from './company-deletion.component';

@NgModule({
  imports: [InfoboxModule, I18nModule, CommonModule],
  declarations: [CompanyDeletionComponent],
  exports: [CompanyDeletionComponent],
})
export class CompanyDeletionModule {}
export { CompanyDeletionComponent };
